import { jsxs as s, Fragment as w, jsx as e } from "react/jsx-runtime";
import b from "react";
import { Verified as g } from "../Verified/index.js";
import { Ratings as D } from "../Ratings/index.js";
import { getContrastColor as W } from "../../utils/colors.js";
import R from "../Dialog/Dialog.js";
import { MadeWithSimplyReview as C } from "../SimplySignature/index.js";
import '../../assets/index4.css';const L = "_testClass_jsev0_1", M = "_card_jsev0_15", k = "_avatar_jsev0_25", N = "_name_jsev0_32", T = "_title_jsev0_43", z = "_description_jsev0_56", F = "_date_jsev0_68", H = "_headlineWrapper_jsev0_80", $ = "_headline_jsev0_80", I = "_text_jsev0_99", O = "_row_jsev0_112", S = "_readmore_jsev0_117", d = {
  testClass: L,
  card: M,
  avatar: k,
  name: N,
  title: T,
  description: z,
  date: F,
  headlineWrapper: H,
  headline: $,
  text: I,
  row: O,
  readmore: S
};
function K({
  title: t,
  description: i,
  rating: l,
  reviewerName: n,
  reviewSource: f,
  reviewSourceLink: _,
  lineClamp: u = 5,
  disableReadMore: j = !1,
  textCardBackgroundColor: r
}) {
  const m = b.useRef(null), c = r || "#ffffff", o = W(c, !0), x = c !== "#ffffff";
  return console.log({ backgroundColor: c }), /* @__PURE__ */ s(w, { children: [
    /* @__PURE__ */ s(
      "div",
      {
        role: "button",
        onClick: () => {
          var a;
          return !j && ((a = m.current) == null ? void 0 : a.showModal());
        },
        className: `${d.card} ${d.widget}`,
        style: { backgroundColor: c, cursor: "pointer" },
        children: [
          /* @__PURE__ */ e("div", { style: { display: "flex", justifyContent: "space-between" }, children: /* @__PURE__ */ e(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "row"
              },
              children: /* @__PURE__ */ e(
                h,
                {
                  reviewerName: n,
                  reviewSource: f,
                  reviewSourceLink: _,
                  rating: l,
                  textCardBackgroundColor: r,
                  textColor: o
                }
              )
            }
          ) }),
          /* @__PURE__ */ s("div", { children: [
            /* @__PURE__ */ e(
              p,
              {
                title: t,
                textCardBackgroundColor: r,
                textColor: o
              }
            ),
            /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
              v,
              {
                lineClamp: u,
                description: i,
                textCardBackgroundColor: r,
                textColor: o
              }
            ) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ s(
      R,
      {
        ref: m,
        textCardBackgroundColor: c,
        onClose: () => {
          var a;
          return (a = m.current) == null ? void 0 : a.close();
        },
        children: [
          /* @__PURE__ */ e(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
                maxHeight: "100%"
              },
              children: /* @__PURE__ */ e(
                h,
                {
                  reviewerName: n,
                  reviewSource: f,
                  reviewSourceLink: _,
                  rating: l,
                  textCardBackgroundColor: r,
                  textColor: o
                }
              )
            }
          ),
          /* @__PURE__ */ s("div", { style: { overflowY: "scroll" }, children: [
            /* @__PURE__ */ e(
              p,
              {
                title: t,
                textCardBackgroundColor: r,
                textColor: o
              }
            ),
            /* @__PURE__ */ e(
              v,
              {
                lineClamp: 1e3,
                description: i,
                textCardBackgroundColor: r,
                textColor: o
              }
            )
          ] }),
          /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(C, { darkMode: x }) })
        ]
      }
    )
  ] });
}
function h({
  reviewerName: t,
  reviewSource: i,
  reviewSourceLink: l,
  rating: n,
  textCardBackgroundColor: f,
  textColor: _
}) {
  return /* @__PURE__ */ e(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "row"
      },
      children: /* @__PURE__ */ s("div", { children: [
        /* @__PURE__ */ s(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            },
            children: [
              /* @__PURE__ */ e(
                "div",
                {
                  className: d.name,
                  style: f ? { color: _ } : {},
                  children: t
                }
              ),
              /* @__PURE__ */ e("div", { style: { marginLeft: 4 } }),
              /* @__PURE__ */ e("div", { style: { height: 20 }, children: /* @__PURE__ */ e(
                g,
                {
                  source: i,
                  sourceLink: l,
                  direction: "right"
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "row",
              marginLeft: -2,
              marginTop: 4
            },
            children: /* @__PURE__ */ e(D, { size: "small", rating: n })
          }
        )
      ] })
    }
  );
}
function p({
  title: t,
  textCardBackgroundColor: i,
  textColor: l
}) {
  return t ? /* @__PURE__ */ e(
    "h4",
    {
      className: d.title,
      style: i ? { color: l } : {},
      children: t
    }
  ) : null;
}
function v({
  lineClamp: t,
  description: i,
  textCardBackgroundColor: l,
  textColor: n
}) {
  return i ? /* @__PURE__ */ e(
    "p",
    {
      className: d.description,
      style: l ? {
        ...y,
        WebkitLineClamp: t,
        color: n
      } : { ...y, WebkitLineClamp: t },
      children: i
    }
  ) : null;
}
const y = {
  fontFamily: "inherit",
  fontSize: 14,
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical",
  color: "#464646"
};
export {
  K as TextReviewCard
};
